import {
  Container,
  SimpleGrid,
  Image,
  Flex,
  Heading,
  Text,
  Stack,
  StackDivider,
  Icon,
  useColorModeValue,
  HStack,
  Box
} from "@chakra-ui/react";
import {
  IoAnalyticsSharp,
  IoLogoBitcoin,
  IoSearchSharp,
} from "react-icons/io5";
import { ReactElement } from "react";
import HomeDetails from "./HomeDetails";


//   interface FeatureProps {
//     text: string;
//     iconBg: string;
//     icon?: ReactElement;
//   }

const Feature = ({ text, icon, iconBg }) => {
  return (
    <Stack direction={"row"} align={"center"}>
      <Flex
        w={8}
        h={8}
        align={"center"}
        justify={"center"}
        rounded={"full"}
        bg={iconBg}
      >
        {icon}
      </Flex>
      <Text fontWeight={600}>{text}</Text>
    </Stack>
  );
};

export default function AboutInHome() {
  return (
    <>
    <div
      // style={{
      //   boxShadow:
      //     "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset",
      // }}
    >
      
        <Flex w={"90%"} m={"auto"} gap={"30px"} flexDir={{base:"column",lg:"row"}} mt={"50px"}>
          <Stack w={{base:"100%",lg:"50%"}}>
            <Text
              textTransform={"uppercase"}
              color={"white"}
              fontWeight={600}
              fontSize={"sm"}
              bg={useColorModeValue("yellow.400")}
              p={2}
              alignSelf={"flex-start"}
              rounded={"md"}
              fontFamily={"Poppins"}
            >
              Our Story
            </Text>
            <Text
            fontFamily={"Poppins"}
            fontWeight={"700"}
            fontSize={"34px"}

            >The Best Coaching Center in Ghogha</Text>
            <Text  fontFamily={"Poppins"}
            fontSize={"18px"}>
              Ghogh's best coaching center with five years of acadamic
              excellence. We proviode top level of coaching for IIT
              JEE,NEET,11th && 12th('CBSE && BSEB'),English Spoken, and Computer
              classes.
            </Text>
            <Text color={"gray.500"}  fontFamily={"Poppins"}>
              Transform your aspirations into achievements with our
              comprehensive IIT JEE coaching program, designed to provide you
              with the skills, knowledge, and confidence to succeed in this
              highly competitive field. Join our institute and receive
              top-quality IIT JEE preparation from experienced instructors who
              are dedicated to your success.
            </Text>
           
          </Stack>
          <Box   w={{base:"auto",lg:"50%"}}>
            <Image
            
              rounded={"md"}
              alt={"feature image"}
              src={
                "https://user-images.githubusercontent.com/103061012/228313861-510cd886-5d74-42ce-a217-22e613b32492.JPG"
              }
              objectFit={"cover"}
              
            />
          </Box>
        </Flex>
      
    </div>
    <HomeDetails/>
    </>
  );
}